<template>
  <div class="pagination">
    <button
      class="prev"
      :class="{ 'disabled': currentPage < 2}"
      @click="previousPage"
    >
      <img src="/static/images/down-arrow-angle.png"></img>
    </button>
    <span>Página {{ currentPage }} de {{ totalPages }}</span>
    <button
      class="next"
      :class="{ 'disabled': currentPage === totalPages}"
      @click="nextPage"
    >
      <img src="/static/images/down-arrow-angle.png"></img>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: Number,
    totalPages: Number
  },
  methods: {
    previousPage() {
      if (this.currentPage > 0) {
        this.$emit('page-change', this.currentPage - 1)
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.$emit('page-change', this.currentPage + 1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    height: 18px;
    width: 18px;
    margin: 0 14px;

    &.disabled {
      opacity: 0.2;
      filter: grayscale(1);
      cursor: not-allowed;
    }

    &.prev {
      transform: rotate(90deg);
    }

    &.next {
      transform: rotate(-90deg);
    }
  }
}
</style>
